import { getBlockProps } from "../blocks-parser";

const tableContentPasteSchema = ({ phrasingContentSchema }) => ({
  tr: {
    allowEmpty: true,
    children: {
      th: {
        allowEmpty: true,
        children: phrasingContentSchema,
        attributes: ["scope"],
      },
      td: {
        allowEmpty: true,
        children: phrasingContentSchema,
      },
    },
  },
});

const tablePasteSchema = (args) => ({
  table: {
    children: {
      thead: {
        allowEmpty: true,
        children: tableContentPasteSchema(args),
      },
      tfoot: {
        allowEmpty: true,
        children: tableContentPasteSchema(args),
      },
      tbody: {
        allowEmpty: true,
        children: tableContentPasteSchema(args),
      },
    },
  },
});

const props = {
  head: {
    type: "array",
    default: [],
    source: "query",
    selector: "thead tr",
    query: {
      cells: {
        type: "array",
        default: [],
        source: "query",
        selector: "td,th",
        query: {
          content: {
            type: "string",
            source: "html",
          },
        },
      },
    },
  },
  table: {
    type: "array",
    default: [],
    source: "query",
    selector: "tbody tr",
    query: {
      cells: {
        type: "array",
        default: [],
        source: "query",
        selector: "td,th",
        query: {
          content: {
            type: "string",
            source: "html",
          },
        },
      },
    },
  },
  foot: {
    type: "array",
    default: [],
    source: "query",
    selector: "tfoot tr",
    query: {
      cells: {
        type: "array",
        default: [],
        source: "query",
        selector: "td,th",
        query: {
          content: {
            type: "string",
            source: "html",
          },
        },
      },
    },
  },
};

const tableSchema = {
  blockSlug: "grigora/table",
  props,
  selector: "table",
  schema: tablePasteSchema,
  transform: (node) => {
    var blockProps = getBlockProps("grigora/table", node.outerHTML, props);

    blockProps = {
      ...blockProps,
      tableHeader:
        blockProps.head &&
        blockProps.head[0] &&
        blockProps.head[0].cells &&
        blockProps.head[0].cells.map((item) => item.content),
      head: undefined,
      table: blockProps.table.map((item) =>
        item.cells.map((cell) => cell.content),
      ),
      tableFooter:
        blockProps.foot &&
        blockProps.foot[0] &&
        blockProps.foot[0].cells &&
        blockProps.foot[0].cells.map((item) => item.content),
      foot: undefined,
    };

    return {
      blockSlug: "grigora/table",
      blockProps: blockProps,
    };
  },
};

export { tableSchema };
